import { Form } from './../Shared/Form';
import { Analytics } from './../../modules/analytics';

export class Chat extends Form {
    constructor(form, settings) {
        super(form, settings);
        this.popup.config = {
            channelmode: 'no',
            fullscreen: 'no',
            height: '850',
            left: '0',
            location: 'no',
            menubar: 'no',
            resizable: 'no',
            scrollbars: 'yes',
            status: 'no',
            titlebar: 'yes',
            toolbar: 'no',
            top: '0',
            width: '450'
        };
    }

    popup() {
        this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            document.getElementById('chat-Started').classList.add('core-u-hidden');

            if (this.validation.invalids.length === 0) {
                const inputsArray   = this.setInputArray(
                    Array.from(this.form.querySelectorAll('input'))
                );
                inputsArray['prefPhoneNumber'] = inputsArray['prefPhoneNumber'].replace(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/, '$1$2$3');

                const queryString   = this.serialize.data(
                    inputsArray
                );
                const windowUrl     = this.url + "?" + queryString;
                const windowOptions = this.popupOptions();
                const newWindow     = window.open(
                    windowUrl,
                    'Mutual of Omaha',
                    windowOptions
                );

                if (window.focus) {
                    newWindow.focus();
                }

                document.getElementById('chat-Started').classList.remove('core-u-hidden');
            }
            const analytics = new Analytics();
            analytics.trackEvent({'category':'technical-Support','action':'click','label':'Start Chat'});

            return false;
        }, false);
    }

    popupOptions() {
        return Object
            .keys(this.popup.config)
            .map((k) => {
                return k + '=' + this.popup.config[k];
            })
            .join(',');
    }
}



// WEBPACK FOOTER //
// ./src/modules/Chat/index.js